(function(){
    const container = document.querySelector('#stories_list');
    const button = document.querySelector('#load_more');
    const filters = document.querySelectorAll('.filter_list');
    if(!container) return;
    if(button){
        button.addEventListener('click', function(){
            const page = parseInt(button.dataset.page) + 1;
            const category = button.dataset.category;
            const postsPerPage = button.dataset.postsperpage;
            button.dataset.page = page;

            container.classList.add('loading');
            fetch(`/wp-json/ap/v1/blog?page=${page}&category=${category}&posts_per_page=${postsPerPage}`)
            .then(response => response.json())
            .then(data => {
                if(data.data){
                    container.insertAdjacentHTML('beforeend', data.data);
                    linkBoxes();
                }
                if(!data.show_more){
                    button.style.display = 'none';
                }
                else{
                    button.style.display = 'block';
                }
                container.classList.remove('loading');
            })
            .catch(function(err){
                console.log(err);
                container.classList.remove('loading');
            });
        });
    }
    if(filters && filters.length){
            filters.forEach((filter)=>{
                filter.addEventListener('click', function(e){
                if(e.target.tagName=='BUTTON'){
                    const id = e.target.dataset.id;
                    if(button){
                        button.dataset.page = 1;
                        button.dataset.category = id;
                    }
                    container.classList.add('loading');
                    filter.querySelectorAll('button').forEach(function(button){
                        button.classList.remove('active');
                    });
                    e.target.classList.add('active');
                    fetch(`/wp-json/ap/v1/blog?page=1&category=${id}`)
                    .then(response => response.json())
                    .then(data => {
                        container.innerHTML = data.data;
                        linkBoxes();
                        if(button){
                            if(!data.show_more){
                                button.style.display = 'none';
                            }else{
                                button.style.display = 'block';
                            }
                        }
                        container.classList.remove('loading');
                    })
                    .catch(function(err){
                        console.log(err);
                        container.classList.remove('loading');
                    });
                }
            });
        });
    }
})()